import type { VoipRoomStore } from './interfaces'

export const actions = {
  setRoomData (this: VoipRoomStore, payload: VoipRoomStore['roomData']): void {
    this.roomData = payload
  },
  setRoomLoading (this: VoipRoomStore, payload: VoipRoomStore['roomLoading']): void {
    this.roomLoading = payload
  },
  setBookingVoip (this: VoipRoomStore, payload: VoipRoomStore['bookingVoip']): void {
    this.bookingVoip = payload
  },
}
